// What every signed-in start reads, asked at once. Otherwise each read waits for the screen the one before it opens:
// the terms, then the workspaces, then the productions, then their summaries. The screens ask the same as before and
// get these answers. A stored workspace or production that is out of reach just answers nothing useful.
import type { Api } from "../api.ts";
import { loadPicks, safeGet, safeSet } from "../auth.ts";
import type { Project } from "../types.ts";
import { createLegalSource } from "./legal.ts";
import { summaryReads } from "./production.ts";
import { loadRecent } from "./recent.ts";

const LAST_WORKSPACE = "filmsquare.lastWorkspace";

/** The workspace the studio opened last: without a pick of your own it is still the one to read ahead. */
export const rememberWorkspace = (ws: string): void => safeSet(LAST_WORKSPACE, ws);

/** How many recent productions to read ahead: what Home shows. */
const RECENT = 6;

export function startReads(api: Api, o: { keySession: boolean }): void {
  const ws = loadPicks().ws ?? safeGet(LAST_WORKSPACE);
  api.preload(() => [
    api.listWorkspaces(),
    api.request("GET", "/me"),
    // an API key's session never asks for the terms
    ...(o.keySession ? [] : [createLegalSource(api).status()]),
    ...(ws ? [api.listProjects(ws), api.getProjectOrder(ws)] : []),
  ]);
  if (!ws) return;
  const recent = loadRecent()
    .slice(0, RECENT)
    .map((id) => ({ id }) as Project);
  for (const read of summaryReads(api, ws, recent)) read.catch(() => {});
}
